import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';

const Installation = () => {
  const [installations, setInstallations] = useState([]);
  const [formData, setFormData] = useState({ name: "", id: null }); // add id for editing
  const [loading, setLoading] = useState(false);

  const fetchInstallations = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}getAllInstallations`);
      if (res.data.success) {
        setInstallations(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching installations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstallations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return;

    try {
      let res;
      if (formData.id) {
        // Update existing installation
        res = await axios.put(`${baseurl}updateInstallation/${formData.id}`, {
          name: formData.name,
        });
      } else {
        // Add new installation
        res = await axios.post(`${baseurl}addInstallation`, { name: formData.name });
      }

      if (res.data.success) {
        setFormData({ name: "", id: null });
        fetchInstallations();
        Swal.fire("Success", res.data.message, "success");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", err.response?.data?.message || "Something went wrong", "error");
    }
  };

  const handleEdit = (inst) => {
    setFormData({ name: inst.name, id: inst.id });
  };

  const handleDelete = async (id) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });

    if (confirmResult.isConfirmed) {
      try {
        const res = await axios.delete(`${baseurl}deleteInstallationById/${id}`);
        if (res.data.success) {
          fetchInstallations();
          Swal.fire('Deleted!', 'Installation has been deleted.', 'success');
        }
      } catch (error) {
        console.error("Error deleting installation:", error);
        Swal.fire('Error!', 'Something went wrong while deleting.', 'error');
      }
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <h4 className="mb-3">{formData.id ? "Edit Installation Type" : "Add Installation Type"}</h4>

          <form className="card p-3 mb-4" onSubmit={handleSubmit}>
            <div className="row g-3 align-items-center">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Installation Type here..."
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              <div className="col-md-3">
                <button type="submit" className="btn btn-primary w-100">
                  {formData.id ? "Update Installation" : "Add Installation"}
                </button>
              </div>
              {formData.id && (
                <div className="col-md-3">
                  <button
                    type="button"
                    className="btn btn-secondary w-100"
                    onClick={() => setFormData({ name: "", id: null })}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </form>

          <div className="card text-start">
            <div className="card-header">All Installation Types</div>
            <div className="card-body" style={{ padding: 0 }}>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                  <Spinner animation="border" />
                </div>
              ) : (
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                 <tbody>
  {installations.length > 0 ? installations.map((inst, index) => {
    const isProtected = inst.name === "Free Installation"; // protect this record
    return (
      <tr 
        key={inst.id} 
        style={isProtected ? { backgroundColor: "#d4edda" } : {} } // light green for protected
      >
        <td>{index + 1}</td>
        <td>
          {inst.name}
          {isProtected && (
            <div style={{ fontSize: "12px", color: "#155724", marginTop: "4px" }}>
              * This row cannot be edited or deleted
            </div>
          )}
        </td>
        <td>{new Date(inst.created_at).toLocaleDateString()}</td>
        <td>
          <button
            className="btn btn-sm btn-warning me-2"
            onClick={() => handleEdit(inst)}
            disabled={isProtected} // disable edit
            title={isProtected ? "This record cannot be edited" : ""}
          >
            Edit
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(inst.id)}
            disabled={isProtected} // disable delete
            title={isProtected ? "This record cannot be deleted" : ""}
          >
            Delete
          </button>
        </td>
      </tr>
    );
  }) : (
    <tr>
      <td colSpan="4" className="text-center">No installations found</td>
    </tr>
  )}
</tbody>


                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Installation;
